// eslint-disable-next-line no-unused-vars
class Pagination {
  constructor (data) {
    this.count = data.count
    this.currentPage = data.currentPage
  }

  change (currentPage, count) {
    this.count = count
    this.currentPage = currentPage
  }

  currentPage () {
    return this.currentPage
  }

  count () {
    return this.count
  }
}
export default Pagination
